module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product20-ac42811c59b39f32fbaa067d2ab83809.jpg";